export enum EB_ICON_TYPE {
  STAR = 'STAR',
  SEARCH = 'SEARCH',
  CART = 'CART',
  INFO = 'INFO',
  GRID = 'GRID',
  LIST = 'LIST',
  CARET_DOWN = 'CARET_DOWN',
  CARET_UP = 'CARET_UP',
  CARET_LEFT = 'CARET_LEFT',
  CARET_RIGHT = 'CARET_RIGHT',
  CLOSE = 'CLOSE',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  VISA = 'VISA',
  MASTER_CARD = 'MASTER_CARD',
  AMEX = 'AMEX',
  DINERS_CLUB = 'DINERS_CLUB',
  CREDIT_CARD = 'CREDIT_CARD',
  EXPAND = 'EXPAND',
  COLLAPSE = 'COLLAPSE',
  RESET = 'RESET',
  CIRCLE = 'CIRCLE',
  HEART = 'HEART',
  EMPTY_HEART = 'EMPTY_HEART',
  FILTER = 'FILTER',
  PENCIL = 'PENCIL',
  PEN = 'PEN',
  CLOCK = 'CLOCK',
  TRASH = 'TRASH',
  ACTIVE = 'ACTIVE',
  SORT_DOWN = 'SORT_DOWN',
  SORT = 'SORT',
  ON = 'ON',
  OFF = 'OFF',
  LINK_OUT = 'LINK_OUT',
  GLOBE = 'GLOBE',
  FILE = 'FILE'
}
